import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_IOS_MOBILE, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

// tempexp_18796-start
interface ExcludeTariffsConfig {
    year?: number[];
    month?: number[];
    variant: string;
}

type FeatureType = ExcludeTariffsConfig | false;

/** CLOUDWEB-18796: Не продавать тарифы 64/128 гб помесячно на вебвью */
const excludeTariffsMobile: FeatureType = IS_IOS_MOBILE
    ? getFeature('exclude-tariffs-by-quota-ios')
    : getFeature('exclude-tariffs-by-quota-and');

export const excludeTariffs: FeatureType = IS_WEBVIEW ? excludeTariffsMobile : getFeature('exclude-tariffs-by-quota');

if (IS_WEBVIEW && excludeTariffsMobile) {
    registerExperiment('only-year-tariff', excludeTariffsMobile.variant, [
        AnalyticEventNames.TARIFFS_SHOWN,
        AnalyticEventNames.TARIFF_CLICK,
        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
    ]);
}
// tempexp_18796-end
